var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "modal-mask" }, [
    _c("div", { staticClass: "modal-wrapper" }, [
      _c(
        "div",
        { staticClass: "modal-dialog modal-xl modal-dialog-scrollable" },
        [
          _c("div", { staticClass: "modal-content" }, [
            _c("div", { staticClass: "modal-header" }, [
              _c("h5", { staticClass: "modal-title" }, [
                _vm._v(_vm._s(_vm.Title)),
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "close",
                  attrs: { type: "button" },
                  on: { click: _vm.close },
                },
                [_vm._v("×")]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal-body" }, [
              _c(
                "div",
                { staticClass: "list-group" },
                _vm._l(_vm.alternativesView, function (a) {
                  return _c(
                    "button",
                    {
                      key: a.AlternativeId,
                      staticClass: "list-group-item list-group-item-action",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return a.toggleIncluded()
                        },
                      },
                    },
                    [
                      a.Included
                        ? _c("span", {
                            staticClass: "fa-regular fa-square-check",
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      !a.Included
                        ? _c("span", { staticClass: "fa-regular fa-square" })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(a.Name))]),
                    ]
                  )
                }),
                0
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal-footer" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-primary",
                  attrs: { type: "button" },
                  on: { click: _vm.confirm },
                },
                [_vm._v("Confirm")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-outline-secondary",
                  attrs: { type: "button" },
                  on: { click: _vm.close },
                },
                [_vm._v("Cancel")]
              ),
            ]),
          ]),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }